"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _internals = require("../../internals");
var _ExtendedErrorInfoPanel = require("../DevHits/ExtendedErrorInfoPanel");
var _ErrorButton = require("../ErrorButton");
var _OperationId = require("../OperationId");
var _PageHeader = require("../PageHeader");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// TODO: Enable the lazy loading of the ExtendedErrorInfoPanel when the previous issue is investigated or resolved
// https://oriflame.visualstudio.com/AppShell/_git/appshell-micro-services/pullrequest/299841?_a=files
// https://oriflame.visualstudio.com/FrontendPlatform/_git/toolbox/pullrequest/299713?_a=files

// const LazyExtendedErrorInfoPanel = lazy(async () => ({
//   default: (await import(/* webpackIgnore: true */'../DevHits/ExtendedErrorInfoPanel')).ExtendedErrorInfoPanel,
// }));

const GenericContent = ({
  errorButtonText,
  errorCode,
  headerText,
  messageText,
  operationId,
  operationResourceId,
  environment,
  developmentInfo
}) => {
  const [showDevInfo, setShowDevInfo] = (0, _react.useState)(false);
  // Disable Operation ID - used by Online in Maintenance pages
  const disableOperationId = (0, _react.useRef)((0, _internals.getUrlQueryParam)('disable-operation-id') === 'true');
  (0, _react.useEffect)(() => {
    const isNotLive = environment !== 'live' && environment !== undefined;
    if (typeof window !== 'undefined' && isNotLive) {
      setShowDevInfo(true);
    }
  }, [environment]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PageHeader.PageHeader, {
      errorCode: errorCode,
      headerText: headerText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: messageText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorButton.ErrorButton, {
      text: errorButtonText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OperationId.OperationId, {
      operationId: operationId,
      disable: disableOperationId.current,
      operationResourceId: operationResourceId
    }), showDevInfo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExtendedErrorInfoPanel.ExtendedErrorInfoPanel, {
      errorCode: errorCode,
      operationId: operationId,
      operationResourceId: operationResourceId,
      developmentInfo: developmentInfo
    }) : null]
  });
};
exports.GenericContent = GenericContent;
//# sourceMappingURL=GenericContent.js.map